<template>
    <div class="BasicModal">
        <slot></slot>
        <div
            @click="closeClickEmit"
            class="BasicModal-close"
        >
            <div class="BasicModal-close-bar"></div>
            <div class="BasicModal-close-bar"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BasicModal',
    methods: {
        closeClickEmit(){
            this.$emit("closeClick");
        }
    }
}
</script>

<style src="styles/components/BasicModal.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/BasicModal.vue